function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSteam = function SvgSteam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 60",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-277,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "steam",
    transform: "matrix(1.61997,0,0,1.61997,162.468,-15.3389)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.994,
    y: 9.469,
    width: 37.038,
    height: 37.038,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.370378,0,0,0.370378,70.994,9.31233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.266,38.962C88.266,43.544 84.537,47.26 79.938,47.26C75.334,47.26 71.608,43.544 71.608,38.962C71.608,34.38 75.336,30.665 79.938,30.665C84.537,30.666 88.266,34.38 88.266,38.962M84.91,52.982L74.824,61.576C74.933,62.262 75.007,62.959 75.007,63.674C75.007,70.99 69.053,76.922 61.711,76.922C55.377,76.922 50.088,72.508 48.748,66.602L23.817,58.175C21.848,59.664 19.398,60.561 16.734,60.561C10.253,60.561 5,55.325 5,48.87C5,42.415 10.254,37.182 16.734,37.182C22.307,37.182 26.96,41.051 28.162,46.236L52.245,54.378C54.591,52.009 57.826,50.524 61.411,50.443L65.018,39.519C65.007,39.302 64.985,39.088 64.985,38.87C64.985,30.615 71.706,23.922 79.993,23.922C88.28,23.922 95,30.614 95,38.87C95,45.41 90.779,50.953 84.91,52.982M24.112,44.869C22.71,42.354 20.019,40.651 16.929,40.651C12.391,40.651 8.711,44.316 8.711,48.836C8.711,53.356 12.391,57.02 16.929,57.02C17.768,57.02 18.576,56.895 19.337,56.662L15.434,55.343C12.288,53.665 11.103,49.765 12.789,46.63C14.475,43.499 18.391,42.32 21.534,43.999L24.112,44.869ZM68.289,38.904C68.289,45.316 73.506,50.515 79.943,50.515C86.38,50.515 91.601,45.316 91.601,38.904C91.601,32.49 86.379,27.291 79.943,27.291C73.506,27.292 68.289,32.491 68.289,38.904M68.518,64.811C68.518,59.93 64.545,55.971 59.645,55.971C58.957,55.971 58.293,56.057 57.651,56.203L62.61,57.879C65.755,59.559 66.936,63.459 65.252,66.59C63.567,69.727 59.651,70.902 56.508,69.225L51.165,67.418C52.28,71.027 55.655,73.65 59.645,73.65C64.545,73.65 68.518,69.691 68.518,64.811",
    style: {
      fillRule: "nonzero"
    }
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSteam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/steam.00eddc64.svg";
export { ForwardRef as ReactComponent };